<template>
  <div>
    <div class="chart-box-top">
      <span class="chart-title">公司一般事件趋势图</span>
      <div class="chart-select-container">
        <div class="el-select-wrapper">
          <el-select v-model="dimension" placeholder="请选择" @change="onDimensionChange">
            <el-option value="month" label="月份时间维度"></el-option>
            <el-option value="dept" label="责任部门维度"></el-option>
          </el-select>
        </div>
        <div class="el-select-wrapper">
          <el-select v-model="symptom" placeholder="请选择">
            <el-option v-for="item in symptomOptions" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div ref="chart" class="chart-main">
    </div>
    <el-dialog title="明细列表" :visible.sync="detailVisible" width="95%">
      <!-- 由于严差明细中，会修改prop，所以将该组件设置为随着对话框的打开/关闭而创建/销毁。可以省去大量watch和初始化数据工作 -->
      <SeriousErrorDetail v-if="detailVisible" ref="detail" :kpi-code="symptom" :company="company"
                          :year="year"
                          :month="barMonth" :initial-dept-id="barDeptId" :dept-ids="barDeptIds"></SeriousErrorDetail>
    </el-dialog>
  </div>
</template>

<script>
import {getRequest} from "../../../utils/request";
import SeriousErrorDetail from "./SeriousErrorDetail";

export default {
  props: {
    year: Number,
    company: String,
  },
  data() {
    return {
      //统计维度
      dimension: "month",
      symptomOptions: [{
        code: "SR-009",
        name: "一类事件（含红线）"
      }, {
        code: "SR-047",
        name: "二类事件"
      }],
      symptom: "SR-009",
      //x轴
      xAxisData: [],
      //万时率
      tenThousandHourRate: [],
      //千次率
      thousandCountRate: [],
      //加权事件数量
      weightedEventCounts: [],
      //目标值
      targets: [0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1, 0.1],
      //红色预警
      redWarnings: [],
      //黄色预警
      yellowWarnings: [],
      //蓝色预警
      blueWarnings: [],
      //部门柱状图颜色池
      deptBarColorPool: ["#198AFF", "#ED6C3B", "#F7B400", "#193c66", "#d2dcef"],
      //是否显示明细列表
      detailVisible: false,
      //用户点击的月份
      barMonth: null,
      //用户点击的部门
      barDeptId: null,
      barDeptIds: [],
      chart: null,
    }
  },
  mounted() {
    let querySymptom = this.$route.query.symptom;
    if (this.symptomOptions.some(option => option.code === querySymptom))
      this.symptom = querySymptom;

    this.onDimensionChange();
    window.addEventListener('resize', () => {
      this.chart && this.chart.resize()
    })
  },
  methods: {
    buildChart() {
      getRequest(`/result/error/chart/serious/${this.dimension}`, {
        company: this.company,
        year: this.year,
        kpiCode: this.symptom,
      }, this.$refs.chart).then(res => {
        this.xAxisData = [];
        this.thousandCountRate = [];
        this.tenThousandHourRate = [];
        this.targets = [];
        this.redWarnings = [];
        this.yellowWarnings = [];
        this.blueWarnings = [];

        //部门series
        let deptSeriesList = [];
        res.data.departments.forEach((item, index) => {
          let color = this.deptBarColorPool[index];
          deptSeriesList.push(this.buildSeries(item, color));
        })

        res.data.reports.forEach(item => {
          //X轴、万时率等
          this.xAxisData.push(item.month + "月");
          this.thousandCountRate.push({value: item.thousandCountRate, full: item});
          this.tenThousandHourRate.push({value: item.tenThousandHourRate, full: item});
          this.targets.push({value: item.groupTarget, full: item});
          this.redWarnings.push({value: item.redWarning, full: item});
          this.yellowWarnings.push({value: item.yellowWarning, full: item});
          this.blueWarnings.push({value: item.blueWarning, full: item});
          //设置各个部门事件数（不存在(或着为0)均设置为0）
          deptSeriesList.forEach(deptSeries => {
            let deptId = deptSeries.deptId;
            let eventCount = item.deptEventCount[deptId];
            deptSeries.data.push({value: eventCount ? eventCount : 0, full: item, deptId: deptId});
          })
        });
        //补充部门的legend和series
        let option = this.getOption();
        deptSeriesList.forEach(item => option.series.unshift(item));

        if (this.chart) this.chart.dispose();
        this.chart = this.$echarts.init(this.$refs.chart);
        //由于严差的series是动态的，所以此处option不能合并
        this.chart.setOption(option, true);
        this.chart.on("click", "series.bar", params => {
          this.barMonth = params.data.full.month;
          this.barDeptId = params.data.deptId === -1 ? null : params.data.deptId;
          this.barDeptIds = [];
          for (let key in params.data.full.deptEventCount) {
            this.barDeptIds.push(Number(key));
          }
          this.detailVisible = true;
        })
        //图例监听鼠标滚轮事件
        this.chart.getZr().on("mousewheel", _.debounce(params => {
          //图例
          if (params.offsetY <= 20) {
            this.onLegendMouseWheel(params);
          }
        }, 10));

        this.$util.adjustYaxis(this.chart, this.$util.getMax(this.tenThousandHourRate, this.targets))
      })
    },
    getOption() {
      return {
        xAxis: {
          data: this.xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
          axisLabel: {
            color: "#bebebe",
            fontSize: 11,
            interval: 0
          },
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 0
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          padding: [5, 10],
          confine: true
        },
        yAxis: [
          {
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#bebebe",
              fontSize: 12,
            },
            name: "起",
            nameTextStyle: {
              color: "#bebebe",
              fontSize: 11,
              //"起"字与左y轴对齐
              align: "right",
              padding: [0, 5, 0, 0]
            },
          },
          {
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#bebebe",
              fontSize: 12,
            },
            name: "万时率",
            nameTextStyle: {
              color: "#bebebe",
              fontSize: 11,
              //"千次率"与右y轴对齐
              align: "center",
              padding: [0, 0, 0, 20]
            },
          },
        ],
        legend: {
          type: "scroll",
          animationDurationUpdate: 300,
          itemWidth: 12,
          itemHeight: 12,
        },
        series: [
          {
            name: "万时率",
            type: "line",
            symbol: "circle",
            symbolSize: "5",
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#b77eff",
                lineStyle: {
                  color: "#b77eff",
                  width: 2,
                },
              },
            },
            data: this.tenThousandHourRate,
            animationDuration: 1000,
          },
          {
            name: "目标值",
            type: "line",
            symbol: "none",
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#3BD393",
                lineStyle: {
                  color: "#3BD393",
                  width: 1,
                },
              },
            },
            data: this.targets,
            animationDuration: 1000,
          }],
      };
    },
    /**
     * 构建责任部门维度图表
     */
    buildChartForDept() {
      getRequest(`/result/error/chart/serious/${this.dimension}`, {
        company: this.company,
        year: this.year,
        kpiCode: this.symptom,
      }, this.$refs.chart).then(res => {
        this.xAxisData = [];
        this.tenThousandHourRate = [];
        this.weightedEventCounts = [];

        res.data.reports.forEach(item => {
          //X轴、万时率等
          this.xAxisData.push({value: item.organization.name, full: item});
          this.tenThousandHourRate.push({value: item.tenThousandHourRate, full: item});
          this.weightedEventCounts.push({value: item.weightedEventCount, full: item});
        });
        let option = this.getOptionForDept();

        if (this.chart) this.chart.dispose();
        this.chart = this.$echarts.init(this.$refs.chart);
        this.chart.setOption(option, true);

        this.chart.on("click", "series.bar", params => {
          this.barMonth = params.data.full.month;
          this.barDeptId = params.data.full.organization.id === -1 ? null : params.data.full.organization.id;
          this.barDeptIds.push(this.barDeptId);
          this.detailVisible = true;
        })
        //图例监听鼠标滚轮事件
        this.chart.getZr().on("mousewheel", _.debounce(params => {
          //图例
          if (params.offsetY <= 20) {
            this.onLegendMouseWheel(params);
          }
        }, 10));

        this.$util.adjustYaxis(this.chart, this.$util.getMax(this.tenThousandHourRate, this.targets))
      })
    },
    /**
     * 责任部门图
     */
    getOptionForDept() {
      return {
        xAxis: {
          data: this.xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#ddd",
            },
          },
          axisLabel: {
            color: "#bebebe",
            fontSize: 11,
            interval: 0
          },
        },
        grid: {
          containLabel: true,
          left: 0,
          right: 0,
          bottom: 0
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
          padding: [5, 10],
          confine: true
        },
        yAxis: [
          {
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#bebebe",
              fontSize: 12,
            },
            name: "起",
            nameTextStyle: {
              color: "#bebebe",
              fontSize: 11,
              //"起"字与左y轴对齐
              align: "right",
              padding: [0, 5, 0, 0]
            },
          },
          {
            splitLine: {
              lineStyle: {
                type: "dashed",
              },
            },
            axisLabel: {
              color: "#bebebe",
              fontSize: 12,
            },
            name: "万时率",
            nameTextStyle: {
              color: "#bebebe",
              fontSize: 11,
              //"千次率"与右y轴对齐
              align: "center",
              padding: [0, 0, 0, 20]
            },
          },
        ],
        legend: {
          type: "scroll",
          animationDurationUpdate: 300,
          itemWidth: 12,
          itemHeight: 12,
        },
        series: [
          {
            name: '事件数量',
            type: 'bar',
            data: this.weightedEventCounts,
            yAxisIndex: 0,
            barWidth: 16,
            itemStyle: {
              color: "#257dff"
            },
          },
          {
            name: "万时率",
            type: "line",
            symbol: "circle",
            symbolSize: "5",
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#b77eff",
                lineStyle: {
                  color: "#b77eff",
                  width: 2,
                },
              },
            },
            data: this.tenThousandHourRate,
            animationDuration: 1000,
          },
        ],
      };
    },

    /**
     * 构建严差的series
     */
    buildSeries(dept, color) {
      return {
        deptId: dept.id,
        name: dept.name,
        type: "bar",
        stack: "total",
        symbol: "none",
        itemStyle: {
          normal: {
            color: color,
          },
        },
        barWidth: 16,
        data: [],
        animationDuration: 1000,
      }
    },
    onLegendMouseWheel(param) {
      param.event.preventDefault();
      let option = this.chart.getOption();
      //图例个数
      let limit = option.series.length;
      //刷新scrollDataIndex
      let dataIndex = option.legend[0].scrollDataIndex;
      dataIndex -= param.wheelDelta;
      if (dataIndex >= 0 && dataIndex < limit) {
        this.chart.dispatchAction({
          type: 'legendScroll',
          scrollDataIndex: dataIndex,
        })
      }
    },
    /**
     * 统计维度变化
     */
    onDimensionChange() {
      switch (this.dimension) {
        case "month":
          this.buildChart();
          break;
        case "dept":
          this.buildChartForDept();
          break
      }
    }
  },
  watch: {
    year() {
      this.onDimensionChange();
    },
    company() {
      this.onDimensionChange();
    },
    symptom() {
      this.onDimensionChange();
    }
  },
  components: {SeriousErrorDetail}
}
</script>

<style scoped lang="less">
.el-select-wrapper {
  width: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/achievement/result/SeriousError.vue